
import { Component, VModel, Vue, Watch } from 'vue-property-decorator'

import { Company } from '@/views/Company/types/company'

import { isEmail } from '@/utils/validation'
import { searchCompanies } from '@/views/Company/utils/company'

import CompanyAutocomplete from '@/components/Autocomplete/company.vue'

@Component({
    inheritAttrs: false,
    components: { CompanyAutocomplete },
})
export default class InvoiceRecipientCombobox extends Vue {
    @VModel() invoiceRecipient!: string | null

    invoiceRecipientItems = ['EHF', 'email']
    invoiceRecipientVal = 'EHF'

    company = null as null | Company
    email = null as null | string
    loading = false

    @Watch('invoiceRecipientVal')
    @Watch('email')
    @Watch('company')
    setInvoiceRecipientVal() {
        if (this.invoiceRecipientVal == 'email') {
            this.invoiceRecipient = this.email
        } else {
            this.invoiceRecipient = this.company?.orgNo ?? null
        }
    }

    @Watch('invoiceRecipient', { immediate: true })
    async initializeValue() {
        if (!this.invoiceRecipient) return

        if (isEmail(this.invoiceRecipient)) {
            this.invoiceRecipientVal = 'email'
            this.email = this.invoiceRecipient
        } else {
            this.loading = true
            this.invoiceRecipientVal = 'EHF'
            const companies = await searchCompanies({
                'filter[orgNo]': this.invoiceRecipient,
                'filter[nationality]': 'NOR',
            })

            this.company = companies[0] ?? null
            this.loading = false
        }
    }
}
